"use strict";

exports.__esModule = true;

var ramda_1 = require("ramda");

var driftTypes_1 = require("../utils/driftTypes");

exports.getIsVideoUserOnly = function (scopes) {
  if (scopes === void 0) {
    scopes = [];
  }

  var scopesWithoutSequences = ramda_1.without([driftTypes_1.DriftScopesIF.SALES_SEQUENCES], scopes);
  return ramda_1.equals([driftTypes_1.DriftScopesIF.video], scopesWithoutSequences) || scopesWithoutSequences.includes(driftTypes_1.DriftScopesIF.video_free) && scopesWithoutSequences.includes(driftTypes_1.DriftScopesIF.video) && scopesWithoutSequences.length === 2;
};

exports.getIsVideoAdmin = function (roles) {
  if (roles === void 0) {
    roles = [];
  }

  return roles.includes(driftTypes_1.DriftRolesIF.video_admin);
};

exports.getIsChatUser = function (scopes) {
  if (scopes === void 0) {
    scopes = [];
  }

  return scopes.includes(driftTypes_1.DriftScopesIF.member);
};

exports.getIsOrgAdmin = function (scopes) {
  if (scopes === void 0) {
    scopes = [];
  }

  return scopes.includes(driftTypes_1.DriftScopesIF.org_admin);
};

exports.getIsReportingUser = function (roles) {
  if (roles === void 0) {
    roles = [];
  }

  return roles.includes(driftTypes_1.DriftRolesIF.reporting);
};

exports.getIsPlaybooksUser = function (roles) {
  if (roles === void 0) {
    roles = [];
  }

  return roles.includes(driftTypes_1.DriftRolesIF.playbooks);
};

exports.getIsCalendarUser = function (scopes, gates) {
  if (scopes === void 0) {
    scopes = [];
  }

  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.contains(driftTypes_1.DriftScopesIF.calendar_user, scopes) || ramda_1.pathOr(false, ['has_calendar_user_license'], gates);
};

exports.getIsPhoneToPhoneUser = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['has_drift_voice'], gates) && !ramda_1.pathOr(false, ['no_drift_voice'], gates);
};

exports.getIsBrowserCallingUser = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return exports.getIsPhoneToPhoneUser(gates) && ramda_1.pathOr(false, ['has_browser_to_phone'], gates);
};

exports.getHasChatToZoom = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['has_chat_to_zoom'], gates);
};

exports.getHasUnifiedNav = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['has_unified_nav'], gates);
};

exports.getIsBotsV2User = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['has_siftrock_bots_v2'], gates);
};

exports.getConversationFreeOrg = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['conversation_free_org'], gates);
};

exports.isFreeOrg = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return !(ramda_1.pathOr(false, ['standard_trial'], gates) || ramda_1.pathOr(false, ['premium_team'], gates) || ramda_1.pathOr(false, ['premium_drift'], gates) || ramda_1.pathOr(false, ['premium_enterprise'], gates));
};

exports.isStandardOrAboveOrg = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['premium_drift'], gates) || ramda_1.pathOr(false, ['premium_enterprise'], gates) || ramda_1.pathOr(false, ['premium_team'], gates);
};

exports.isProOrAboveOrg = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['premium_enterprise'], gates) || ramda_1.pathOr(false, ['premium_team'], gates);
};

exports.isPremiumOrAboveOrg = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['premium_enterprise'], gates);
};

exports.hasCalendarRouting = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['has_calendar_routing'], gates);
};

exports.hasABMNotifications = function (gates) {
  if (gates === void 0) {
    gates = {};
  }

  return ramda_1.pathOr(false, ['ABM'], gates);
};

exports.getCanSeeAllConvos = function (scopes) {
  if (scopes === void 0) {
    scopes = [];
  }

  return scopes.includes(driftTypes_1.DriftScopesIF.convoALL);
};

exports.getIsRbacUser = function (user) {
  return user.workspaceRoles && user.workspaceRoles.length > 0;
};

exports.hasFeature = function (userFeatures, requiredFeature) {
  if (userFeatures === void 0) {
    userFeatures = {};
  }

  if (!requiredFeature) {
    return false;
  }

  var featureName = requiredFeature.featureName,
      accessLevel = requiredFeature.accessLevel;
  var featureLevelMap = userFeatures[featureName];

  if (!featureLevelMap) {
    return false;
  }

  var levelsForFeature = Object.keys(featureLevelMap);
  return levelsForFeature.some(function (level) {
    return driftTypes_1.FEATURE_ACCESS_LEVELS[level] >= driftTypes_1.FEATURE_ACCESS_LEVELS[accessLevel];
  });
};

var checkDefaultRole = function checkDefaultRole(roleName, user) {
  var workspaceRoles = ramda_1.pathOr([], ['workspaceRoles'], user);

  if (!workspaceRoles || !workspaceRoles.length) {
    return false;
  }

  var defaultRoleNames = workspaceRoles.filter(function (wsRole) {
    return wsRole.role.isGlobal;
  }).map(function (wsRole) {
    return wsRole.role.name;
  });
  return defaultRoleNames.includes(roleName);
};

exports.getIsRbacAdmin = function (user) {
  return checkDefaultRole('Admin', user);
};